// @ts-nocheck
export const BREAK_COLOR_GREEN = '#4bb567ff';
export const BREAK_COLOR_YELLOW = 'rgb(190, 142, 0)';
export const BREAK_COLOR_RED = '#f70303ff';

export const formatBreakTime = (seconds) => {
  const safe = Math.max(0, Math.floor(Number(seconds) || 0));
  const minutes = String(Math.floor(safe / 60)).padStart(2, '0');
  const secs = String(safe % 60).padStart(2, '0');
  return `${minutes}:${secs}`;
};

export const getBreakCapsuleColor = (countdownSeconds, totalSeconds) => {
  if (!totalSeconds || countdownSeconds === null || countdownSeconds === undefined) {
    return BREAK_COLOR_GREEN;
  }
  if (totalSeconds === 0) return BREAK_COLOR_GREEN;

  const percentRemaining = (countdownSeconds / totalSeconds) * 100;
  if (percentRemaining <= 25) return BREAK_COLOR_RED;
  if (percentRemaining <= 50) return BREAK_COLOR_YELLOW;
  return BREAK_COLOR_GREEN;
};

export const resolveBreakFromRow = ({ agent, user, activeUserBreak } = {}) => {
  if (user?.break_id && user?.breakDetail) {
    return {
      title: user.breakDetail.title,
      durationMinutes: Number(user.breakDetail.duration || 0),
      startedAt: activeUserBreak?.start_at || user.updated_at,
    };
  }

  if (agent?.break_id && agent?.breakDetail) {
    return {
      title: agent.breakDetail.title,
      durationMinutes: Number(agent.breakDetail.duration || 0),
      startedAt: agent.updated_at,
    };
  }

  return null;
};

export const computeBreakCountdown = (breakInfo, currentTimeSec) => {
  if (!breakInfo?.startedAt) return null;
  const totalSeconds = breakInfo.durationMinutes * 60;
  const startedSec = Math.floor(new Date(breakInfo.startedAt).getTime() / 1000);
  return totalSeconds - (currentTimeSec - startedSec);
};
